export const FETCH_CHATS_SUCCESS = 'FETCH_CHATS_SUCCESS';
export const FETCH_CHATS_FAILURE = 'FETCH_CHATS_FAILURE';
export const CREATE_CHAT_SUCCESS = 'CREATE_CHAT_SUCCESS';
export const CREATE_CHAT_FAILURE = 'CREATE_CHAT_FAILURE';
export const DELETE_CHAT_SUCCESS = 'DELETE_CHAT_SUCCESS';
export const DELETE_CHAT_FAILURE = 'DELETE_CHAT_FAILURE';
export const RENAME_CHAT_SUCCESS = 'RENAME_CHAT_SUCCESS';
export const RENAME_CHAT_FAILURE = 'RENAME_CHAT_FAILURE';
export const LOGOUT_SUCCESS = 'LOGOUT_SUCCESS';
export const CLEAR_CHAT_ERROR = 'CLEAR_CHAT_ERROR';